import { render, staticRenderFns } from "./Locs.vue?vue&type=template&id=d9ad21c8"
import script from "./Locs.vue?vue&type=script&lang=js"
export * from "./Locs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports